import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import logo from '@/assets/Logo.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

const MenuHeader = ({ onSelectRestaurant, selectedRestaurantId }) => {
    const navigate = useNavigate();
    const [restaurants, setRestaurants] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const fetchRestaurants = async () => {
        try {
            const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/get-restaurants-list`);
            if (response.status === 200) {
                const activeRestaurants = response.data.filter(restaurant => restaurant.is_enabled);
                setRestaurants(activeRestaurants);
            } else {
                console.error('Failed to fetch restaurants');
            }
        } catch (error) {
            console.error('Error fetching restaurants:', error);
        }
    };

    const handleRestaurantChange = (id) => {
        localStorage.setItem('restaurant_id_ref', id);
        onSelectRestaurant(id);
    };

    useEffect(() => {
        fetchRestaurants();
    }, []);

    // Style bouton harmonisé avec RestaurantSelector
    const getButtonClass = (id) =>
        `flex items-center justify-center font-bold w-full rounded-lg px-4 py-2 text-center text-sm shadow-xl transition-colors duration-200 ${
            id === selectedRestaurantId
                ? 'bg-primary text-white border-2 border-primary'
                : 'bg-white text-primary border-2 border-primary hover:bg-primary hover:text-white'
        }`;

    return (
        <div className="flex justify-between items-center p-4 bg-white bg-opacity-50 shadow-md rounded-lg m-4">
            <div className="flex items-center">
                <img src={logo} alt="logo" className="h-10 mr-4 cursor-pointer" onClick={() => navigate('/')} />
                <div className="flex md:space-x-4">
                    {isMobile ? (
                        <div className="w-[220px]">
                            <Swiper
                                spaceBetween={12}
                                slidesPerView={2}
                                navigation
                                pagination={{ clickable: true }}
                            >
                                {restaurants.filter(r => !r.is_no_limit).map((restaurant) => (
                                    <SwiperSlide key={restaurant.id}>
                                        <button
                                            className={getButtonClass(restaurant.id)}
                                            onClick={() => handleRestaurantChange(restaurant.id)}
                                            style={{ minWidth: '120px', margin: '0 auto' }}
                                        >
                                            {restaurant.name.split('-').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                        </button>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    ) : (
                        restaurants.filter(r => !r.is_no_limit).map((restaurant) => (
                            <button
                                key={restaurant.id}
                                onClick={() => handleRestaurantChange(restaurant.id)}
                                className={getButtonClass(restaurant.id)}
                                style={{ minWidth: '160px' }}
                            >
                                {restaurant.name.split('-').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </button>
                        ))
                    )}
                </div>
            </div>
            {!isMobile && <button onClick={() => navigate('/commande/adresse')} className="bg-primary text-white px-4 py-2 rounded-full">
                Commander
            </button>}
        </div>
    );
};

export default MenuHeader;
